import React, {useState, useEffect, useRef, useMemo} from "react";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import {isMobile} from "react-device-detect"
import {Helmet  } from 'react-helmet-async'
import {Links} from '../routes/PathLink'
//import {useAuth} from '../provider/AuthProvider'

import {
  useSmeCompaniesQuery , 
  useSmeSectorQuery
} from '../data/company';



import { Table } from "../components/ui/table";
//import Pagination from '../components/ui/pagination';
import { Pagination, Select } from "antd";
import { t } from "i18next";
import { amount_format, APP_URL, APP_NAME } from "../components/config/Common";
import Breadcrumb  from "../components/Breadcrumb";
import SMECompanyTable  from "../components/SMECompanyTable";
import {ArrowNext}  from "../components/icons/arrow-next";
import Seo from 'components/seo/seo'
import { FaExternalLinkAlt } from "react-icons/fa";
import { GoLinkExternal } from "react-icons/go";
import Input from 'components/ui/input.jsx';
import { BsSearch } from "react-icons/bs";
//import {useSectorQuery} from '../data/sector-details';


const SMECat = () => {	
	const navigate = useNavigate();
	
	const [product_slug, setProduct_slug] = useState('');	
	const [cat_arr, setCatArr] = useState([])	
	const [canonicalurl , setCanonicalurl] = useState('');	
	const [description, setDescription] = useState('');
  const [searchQuery, setSearchQuery] = useState(null);
  
	const {slug} = useParams()
	//const { isUser, loginToken } = useAuth();
	//const { addCartItem, cartItem, updateItemQty, deleteCartItem, checkItemInCart, itemCartQty } = useCart();
	
	const [metaTitle, setMetaTitle] = useState()
	const [metaDesc, setMetaDesc] = useState()
	const [user_type, setUser_type] = useState('');
  const [snipetData, setSnipetData] = useState('');

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [orderBy, setOrder] = useState('created_at');
  const [sortedBy, setColumn] = useState('desc');
  
  // SORTING
  const [sortInfo, setSortInfo] = useState({ key: null, order: null });
  const { search } = useLocation();
    const parameters = new URLSearchParams(search);
    let status_p = parameters.get('status');
    let show_p = parameters.get('show');
  
 

  const onPagination = (current) => {
    console.log("current Page",current);
    setPage(current);
  }
    
  
	//console.log("slug",slug);
	const {
		smedata,
    sector,
    paginatorInfo,
		isLoading,
		error,
	} = useSmeCompaniesQuery({ 
    slug,
    limit: pageSize,
    page,    
    orderBy,
    sortedBy,
	});

   const {
          sectors,
      } = useSmeSectorQuery({         
          limit: pageSize,
          page,    
          orderBy,
          sortedBy,
          search:searchQuery,
      }); 
      


const totalPages = Math.ceil(paginatorInfo?.total / pageSize);

const breadcrumb = [
  {
    name:'Home',
    link:`${process.env.REACT_APP_URL}`,
  },
  {
    name:`Sme Stocks`,
    link:`${process.env.REACT_APP_URL}${Links.SMEMARKET}`
  },
   {
        name: sector?.name || 'Loading...',
    link:null
  }
];


  useEffect(() => {
   setMetaTitle(`${sector?.name} SME Stocks in India – List of Small & Medium Companies- ${APP_NAME}`);
	 setMetaDesc(`Discover all SME stocks in the ${sector?.name} sector. Explore small and medium companies with financials, growth data, and performance insights.`);
	
  }, [sector]); 

 const onPageSize = (value) => {
    setPageSize(value);
    setPage(1);
  }
   const searchSector = (val) => {
        //console.log('sq---', val)
        setSearchQuery(val)
      }
  
    return (
      <>
      
    <Seo 
        title={`${metaTitle}`}
        desc={metaDesc && metaDesc.substring(0, 200)}
        url={`${APP_URL}/sme-stocks/${slug}`}
      />
		<Header  />        
        <div className="space-y-5 px-5">
            <Breadcrumb breadcrumb={breadcrumb} />
          {/** comming soon section start here  */}
          {/*} <div className="bg-white border border-accent/40 rounded-lg p-6 text-center">
                <h1 className="text-4xl font-bold mb-4"> SME Section</h1>
        <p className="text-xl text-accent font-semibold mb-3">
                Coming Soon 🚀
              </p>

        <p className="text-gray-500 max-w-md mx-auto">
          We are currently working on SME data and analytics. 
          This feature will be available soon.
        </p>
      </div>*/}
 {/** comming soon section end  start here  */}
 
            <section className=" shadow-sm z-50 rounded-xl px-5">

               
                <div className="flex w-full gap-8 flex-wrap justify-between">

                <section className="w-full lg:w-[66%] bg-white shadow-sm rounded-xl p-5">                        
                  <h2 className="text-2xl">SME Stocks</h2>
                  {sector?.name &&  <p className="text-sm text-gray-500 uppercase">
          {sector.name}
        </p>
        }
                 <SMECompanyTable 
                        data={smedata} 
                        pageSize={pageSize} 
                        isLoading={isLoading} 
                        paginatorInfo={paginatorInfo}
                        totalPages={totalPages}
                        onPagination={onPagination}
                        onPageSize={onPageSize}
                    />
                </section> 

                <section className="w-full lg:w-[31%] bg-white shadow-sm rounded-xl px-5 py-3">
                                        <div className="flex flex-row items-center justify-between gap-5 pb-5">
                                        <h1 className="text-heading text-2xl pt-3">Sectors</h1>
                                        <div className="relative">
                                            <div className="absolute inset-y-0 left-0 top-3 flex items-center pl-3 pointer-events-none">
                                            <BsSearch className="w-3 h-3 text-black" />
                                            </div>
                                            <Input 
                                            dimension='small' 
                                            onChange={(e) => searchSector(e.target.value)} 
                                            value={searchQuery}
                                            placeholder='Search sector by name...'
                                            inputClassName="!h-8 !pl-8 !w-[50px] focus:!w-[250px] transition-[width] duration-300 ease-in-out"
                                            />
                                        </div>
                                        </div>
                
                                        <div className="flex flex-wrap w-full items-center justify-start gap-3">
                                            {sectors?.map((val, key) => (
                                                <div className="group border border-default rounded px-3 py-2 hover:bg-accent transition-colors duration-300">
                                                    <Link to={`${APP_URL}${Links.SMEMARKET}/${val.slug}`}>
                                                    <div className="text-sm text-gray-500 group-hover:text-white transition-colors duration-300">{val.name} <span className="text-xs">[{val.sme_count}]</span></div>
                                                    </Link>
                                                </div>
                                            ))
                                            }
                                            </div>
                                    </section>
                </div>
            </section>
        </div>
		<Footer />
		</>
		);
};

export default SMECat;